import { CartOutput } from "@brushfire/types";
import React, { useState, useEffect } from "react";
import Icon from "../Icon";
import moment from "moment";
import { IntlShape } from "react-intl";

export interface CartBadgeProps {
	cartData: CartOutput;
	isAssigned?: boolean;
	currency: string;
	onClick?: (evt: React.MouseEvent) => void;
	useCartTotal: boolean;
	intl: IntlShape;
}

const CartBadge: React.FC<CartBadgeProps> = ({
	cartData,
	isAssigned = false,
	currency,
	onClick,
	useCartTotal,
	intl,
}) => {
	const [remainingTime, setRemainingTime] = useState<string>();
	const [isTimerReady, setIsTimerReady] = useState<boolean>(false);
	const { attendees, total, displayPrice } = cartData;

	useEffect(() => {
		if (cartData.expiresAt) {
			const expirationTime = moment(cartData.expiresAt);
			let timeLeft = moment(expirationTime.diff(moment()));
			const expired = timeLeft.minutes() === 0 && timeLeft.seconds() === 0;

			if (!expired) {
				setRemainingTime(timeLeft.format("mm:ss"));
				setIsTimerReady(true);
			}

			const cartTimerInterval = setInterval(() => {
				timeLeft = moment(expirationTime.diff(moment()));
				if (expirationTime.isBefore(moment())) {
					setRemainingTime("00:00");
				} else if (timeLeft.minutes() !== 0 || timeLeft.seconds() !== 0) {
					setRemainingTime(timeLeft.format("mm:ss"));
				} else {
					setRemainingTime("00:00");
				}
			}, 1000);
			return () => {
				clearInterval(cartTimerInterval);
			};
		}
		setIsTimerReady(true);
	}, [cartData.expiresAt]);

	return isTimerReady ? (
		<button className={`sectioned-pills`} onClick={onClick} tabIndex={2} aria-label="Cart">
			{cartData.expiresAt && <div className="sectioned-pills-section pill-timer">{remainingTime}</div>}
			<div className="sectioned-pills-section" aria-label={`${attendees?.length} items`}>
				<Icon icon="user-friends" badge={attendees?.length} />
			</div>
			{total > 0 && (
				<div className="sectioned-pills-section" aria-label="Total">
					{intl.formatNumber(useCartTotal ? total ?? 0 : displayPrice ?? 0, { style: "currency", currency })}
				</div>
			)}
		</button>
	) : null;
};

export default CartBadge;
